import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const SimplePlannerIcon = {
  name: 'SimplePlannerIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "4 0 33 34.4",
        fill: "currentColor",
        "stroke-width": "0px"
      },
      "class": "feather feather-document-search"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M9.188,6.237h23.77c1.134.001,2.053.92,2.054,2.054v10.135l-.606-.546c-2.182-1.954-5.516-1.842-7.562.253-.802.822-1.326,1.874-1.5,3.009-.041.27-.061.543-.061.816,0,1.256.429,2.474,1.218,3.451l.48.592H9.188c-1.134-.001-2.053-.92-2.054-2.054v-15.656c.001-1.134.92-2.053,2.054-2.054ZM34.288,16.86v-8.569c-.001-.734-.596-1.328-1.33-1.328H9.188c-.733.001-1.327.595-1.328,1.328v15.656c.001.733.595,1.327,1.328,1.328h16.329c-.625-.994-.956-2.143-.956-3.317,0-.31.023-.62.07-.926.197-1.285.792-2.477,1.7-3.407,2.113-2.16,5.475-2.483,7.96-.764h-.003Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M34.277,10.599H7.777v-.726h26.5v.726Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M19.125,8.883h-9.421c-.2,0-.363-.163-.363-.363s.163-.363.363-.363h9.421c.2,0,.363.163.363.363s-.163.363-.363.363Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M28.538,13.491H10.574c-.194,0-.351-.158-.351-.352,0-.194.157-.35.351-.351h17.964c.194,0,.352.158.352.352,0,.194-.158.351-.352.351Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M29.389,25.383c-.139,0-.272-.055-.37-.153l-2.522-2.523c-.204-.204-.205-.535,0-.74,0,0,0,0,0,0,.204-.204.535-.205.74,0,0,0,0,0,0,0l2.523,2.522c.204.204.205.535,0,.74-.098.098-.231.153-.37.153h0Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M29.387,25.383c-.143,0-.279-.058-.378-.161-.2-.208-.193-.54.015-.739,0,0,0,0,0,0l5.262-5.043c.208-.2.54-.193.739.015,0,0,0,0,0,0,.2.208.193.54-.015.739,0,0,0,0,0,0l-5.26,5.043c-.098.094-.228.146-.364.145Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M28.538,16.224H10.574c-.194,0-.351-.158-.351-.352,0-.194.157-.35.351-.351h17.964c.194,0,.352.158.352.352,0,.194-.158.351-.352.351Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M25.993,18.957h-15.421c-.194,0-.352-.158-.352-.352h0c0-.194.158-.351.352-.351h15.421c.194,0,.352.158.352.352h0c0,.194-.158.351-.352.351Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M24.558,22.165h-13.987c-.194,0-.352-.158-.352-.352h0c0-.194.158-.351.352-.351h13.987c.194,0,.352.158.352.352h0c0,.194-.158.351-.352.351Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M33.403,8.883h-2.465c-.2,0-.363-.163-.363-.363s.163-.363.363-.363h2.465c.2,0,.363.163.363.363s-.163.363-.363.363Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M30.761,28.163c-1.871.001-3.642-.844-4.818-2.3-.13-.152-.113-.381.039-.512.152-.13.381-.113.512.039.004.005.008.009.012.014,1.891,2.36,5.337,2.741,7.697.85,2.36-1.891,2.741-5.337.85-7.697-.196-.245-.412-.472-.647-.679-.149-.134-.161-.364-.026-.513.133-.147.36-.161.509-.029,2.555,2.279,2.779,6.198.5,8.754-1.177,1.319-2.86,2.073-4.628,2.073Z"
        }
      })
    ]);
  }
};

export default SimplePlannerIcon;